import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OBTENIR_DADES,
  VISUALITZACIO_OBTENIR_OBSERVACIONS
} from "../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case `${VISUALITZACIO_OBTENIR_DADES}_EN_CURS`:
    case `${VISUALITZACIO_OBTENIR_OBSERVACIONS}_EN_CURS`:
      return true;

    case `${VISUALITZACIO_OBTENIR_DADES}_SUCCESS`:
    case `${VISUALITZACIO_OBTENIR_DADES}_ERROR`:
    case `${VISUALITZACIO_OBTENIR_OBSERVACIONS}_SUCCESS`:
    case `${VISUALITZACIO_OBTENIR_OBSERVACIONS}_ERROR`:
      return false;

    default:
      return state;
  }
};

export default peticioEnCurs;

export const getPeticioEnCurs = state => state;
export const getPeticioError = state => state.error;
